import type { MoreActions } from '@confluence/content-types-header/entry-points/MoreActions';

import { ContentTypesActionsService } from './content-types-actions-service';

export const contentMoreActionsService = new ContentTypesActionsService<MoreActions>();
